export const IAS           = 'IAS';
export const MOAT          = 'Moat';
export const DOUBLE_VERIFY = 'DoubleVerify';


// WEBPACK FOOTER //
// ./src/Services/Measurement/ExternalProviders/ProviderTypes.js